export const ORBIT_NODES = [
  {
    angle: 0,
    label: 'Consultation',
    title: 'Consultation Hub',
    desc: 'Access deep individual matrix alignments with direct predictive guidance workflows.',
    color: '#F6C16B',
    borderClass: 'border-[#F6C16B]/40',
    textClass: 'text-[#F6C16B]',
    paths: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  },
  {
    angle: 60,
    label: 'Academy',
    title: 'Vedic Academy',
    desc: 'Master ancestral astronomical charting paradigms via intensive, structured global modules.',
    color: '#F2A007',
    borderClass: 'border-[#F2A007]/40',
    textClass: 'text-[#F2A007]',
    paths: [
      'M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z',
      'M22 10v6',
      'M6 12.5V16a6 3 0 0 0 12 0v-3.5',
    ],
  },
  {
    angle: 120,
    label: 'Shop',
    title: 'Divine Boutique',
    desc: 'Acquire authenticated remedial elements, cosmic talismans, and certified mineral assets.',
    color: '#E8770F',
    borderClass: 'border-[#E8770F]/40',
    textClass: 'text-[#E8770F]',
    paths: ['M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z', 'M3 6h18', 'M16 10a4 4 0 0 1-8 0'],
  },
  {
    angle: 180,
    label: 'Horoscope',
    title: 'Horoscope Matrix',
    desc: 'Real-time macro lunar transit monitors compiled for optimal action parameters.',
    color: '#E6C878',
    borderClass: 'border-[#E6C878]/40',
    textClass: 'text-[#E6C878]',
    circle: { cx: 12, cy: 12, r: 4 },
    paths: [
      'M12 2v2',
      'M12 20v2',
      'm4.93 4.93 1.41 1.41',
      'm17.66 17.66 1.41 1.41',
      'M2 12h2',
      'M20 12h2',
      'm6.34 17.66-1.41 1.41',
      'm19.07 4.93-1.41 1.41',
    ],
  },
  {
    angle: 240,
    label: 'Knowledge',
    title: 'Knowledge Repository',
    desc: 'Explore curated astronomical source indexes and technical textual analysis maps.',
    color: '#F4C430',
    borderClass: 'border-[#F4C430]/40',
    textClass: 'text-[#F4C430]',
    paths: [
      'M12 7v14',
      'M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z',
    ],
  },
  {
    angle: 300,
    label: 'Remedies',
    title: 'Targeted Remedies',
    desc: 'Deploy tailored energetic course-corrections to alleviate multi-planetary orbital drag.',
    color: '#FF8A4C',
    borderClass: 'border-[#FF8A4C]/40',
    textClass: 'text-[#FF8A4C]',
    paths: [
      'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z',
    ],
  },
]

export const OUTER_TICKS = Array.from({ length: 48 }, (_, i) => i * 7.5)
export const INNER_SPOKES = [0, 60, 120, 180, 240, 300]
